import { IStore } from "../IStore";

export const selectLoggedIn = (state: IStore): boolean | undefined =>
  state.auth.loggedIn;
export const selectLoginRedirectPath = (state: IStore): string | undefined =>
  state.auth.loginRedirectPath;
export const selectShouldResetClient = (state: IStore): boolean =>
  state.auth.shouldResetClient;
